module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/mp4-61a39d366577f3fc83bb60d0a0e671bd.svg";